module.exports = __webpack_public_path__ + "img/1.17_Russian_road_sign.c704cd75.svg";